// 179 C.2 — THIS FILE USED TO MIRROR A MATRIX. `PUT /:id/status` and its
// STATUS_TRANSITIONS are gone from the server (no caller; `draft` and `ready`
// unreachable since Phase 35 made every new pro forma `unpaid` at creation),
// and the client copy — TRANSITIONS, canTransitionTo, availableTransitions —
// went with it: nothing imported them. What remains is the one thing that
// has callers (InvoiceView, matterListCfg, ProFormaModal): the status badge
// tooltip. Its `draft` and `ready` arms named buttons that do not exist and
// are gone too; the rows those arms read left the seed with them.

import type { Invoice } from "@shared/entities";
import { tImperative as _tImp } from "../i18n";

// Gate 4 C3b — status badge tooltip helper. Per UX 3.3: "what does this badge
// mean and what should the user do next?" guidance.
// 59 §3 — [key, fallback], the shape invoiceFetch.ts established. The
// sentences are UI chrome and not document text, so they follow the READER's
// locale — the B.5 boundary. Resolved at call time, never at module load.
const STATUS_BADGE_TOOLTIPS: Record<string, [string, string]> = {
  unpaid: [
    "invoice.status_tip.unpaid",
    "En attente de paiement. Enregistrez les paiements à mesure qu'ils arrivent.",
  ],
  partially_paid: [
    "invoice.status_tip.partially_paid",
    "Paiement partiel reçu. Enregistrez les paiements complémentaires.",
  ],
  paid: [
    "invoice.status_tip.paid",
    "Entièrement payé en LexCRM. Cliquez sur Envoyer à Peppol pour finaliser.",
  ],
  cancelled: [
    "invoice.status_tip.cancelled",
    "Annulé. Cliquez sur Restaurer pour réactiver.",
  ],
};

// 179 C.3 — `INVOICED_BADGE_TOOLTIPS` (the "Envoyé à Peppol" family, keyed on
// billitSubmittedAt) STOOD HERE: a state no live path reached.

export function getStatusBadgeTooltip(invoice: Invoice | null | undefined) {
  if (!invoice) return "";
  const hit = STATUS_BADGE_TOOLTIPS[invoice.paymentStatus];
  return hit ? _tImp(hit[0], { fallback: hit[1] }) : "";
}
